import { create } from 'superstruct'

import { LastRoomsType, LastRooms } from './useLastRooms.types'

const LOCAL_STORAGE_KEY = 'WEVE_CONTENT_TOOLS:LAST_ROOMS'

const storage = {
  get(): LastRooms | null {
    try {
      const data = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (data === null) {
        return null
      }
      return create(JSON.parse(data), LastRoomsType)
    } catch {
      return null
    }
  },
  set(value: LastRooms) {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(value))
    } catch {
      // do nothing
    }
  },
  reset() {
    try {
      localStorage.removeItem(LOCAL_STORAGE_KEY)
    } catch {
      // do nothing
    }
  },
}

export default storage
